import React from 'react';
import { useTranslation } from 'react-i18next';
import { paths } from '@app/constants';
import { HTTPStatusCodes } from '@data';
import { Button, AntdResult, useTheme, AntdTypography } from '@ui';

const NoMatchPage = () => {
  const { Text } = AntdTypography;
  const { t } = useTranslation();
  const { bgColor } = useTheme();

  return (
    <div className="h-screen" style={{ backgroundColor: bgColor }}>
      <AntdResult
        status={HTTPStatusCodes.NOT_FOUND}
        title={<Text className="text-white">{HTTPStatusCodes.NOT_FOUND}</Text>}
        subTitle={<Text className="text-white">{t('no_match_page.not_found')}</Text>}
        extra={<Button href={`/${paths.app}`}>{t('common.back_home')}</Button>}
      />
    </div>
  );
};

export default NoMatchPage;
